var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetexpand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 3,
    fill: "#B38FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0698 3.20312H5.92592C5.01032 3.20312 4.26666 4.03806 4.26666 5.05533V11.8163C4.26666 12.6801 4.82118 13.0447 5.50036 12.6273L7.59808 11.3269C7.8216 11.1877 8.18269 11.1877 8.40192 11.3269L10.4996 12.6273C11.1788 13.0495 11.7333 12.6849 11.7333 11.8163V5.05533C11.729 4.03806 10.9854 3.20312 10.0698 3.20312ZM9.0725 7.71367H8.32024V8.58219C8.32024 8.77893 8.17409 8.94207 7.99785 8.94207C7.8216 8.94207 7.67545 8.77893 7.67545 8.58219V7.71367H6.9232C6.74695 7.71367 6.6008 7.55052 6.6008 7.35379C6.6008 7.15705 6.74695 6.9939 6.9232 6.9939H7.67545V6.18296C7.67545 5.98623 7.8216 5.82308 7.99785 5.82308C8.17409 5.82308 8.32024 5.98623 8.32024 6.18296V6.9939H9.0725C9.24874 6.9939 9.39489 7.15705 9.39489 7.35379C9.39489 7.55052 9.24874 7.71367 9.0725 7.71367Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetexpand);
export default __webpack_public_path__ + "static/media/assetexpand.1e673563.svg";
export { ForwardRef as ReactComponent };